/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Tab_OtherInputs */

const en_fc_dl_tab_other = /** @type {(inputs: Fc_Dl_Tab_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web & FreeBSD`)
};

/**
* | output |
* | --- |
* | "Web & FreeBSD" |
*
* @param {Fc_Dl_Tab_OtherInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_tab_other = /** @type {((inputs?: Fc_Dl_Tab_OtherInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Tab_OtherInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_tab_other(inputs)
});
export { fc_dl_tab_other as "fc.dl.tab.other" }